import he from 'he'

// css string to object
export const parseStyle = (styleString = '') => {
  if (!styleString) return {}
  const decoded = he.decode(styleString).replace(/^"+|"+$/g, '') // 移除多余引号
  return decoded
    .split(';')
    .filter(Boolean)
    .reduce((acc, item) => {
      const [key, value] = item.split(':').map((s) => s.trim())
      if (!key || !value) return acc
      const camelKey = key.replace(/-([a-z])/g, (_, letter) =>
        letter.toUpperCase(),
      )
      acc[camelKey] = value
      return acc
    }, {})
}

// return boolean isExternal link
export const isExternalLink = (to) => {
  return /^https?:\/\//.test(to)
}

export const seoDataBuilder = (contentfulSeoData) => {
  const {
    pageTitle,
    pageDescription: { pageDescription } = {},
    shareImages,
  } = contentfulSeoData || {}
  const shareImage = shareImages?.[0]?.file?.url
    ? `https:${shareImages[0].file.url}`
    : null

  return { title: pageTitle, description: pageDescription, image: shareImage }
}
